import React from "react";
import { Redirect } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import "../DeliveryBoys/riderReport.css";
import { canSettle } from "../Settlements/access";
import "../Settlements/settlements.css";
import CollectionsList from "./CollectionsList";

export default function DeliveryboyReports() {
  if (!canSettle()) return <Redirect to="/orders" />;
  return (
    <div id="main-wrapper">
      <MainHeader />
      <Header name="Rider Collection" subHeading="What each rider paid the office" />
      <NavBar />
      <div className="content-body" style={{ minHeight: "100vh" }}>
        <CollectionsList />
      </div>
      <Footer />
    </div>
  );
}
